import { toJSON } from "@suse-o11y/to-json";

/**
 * Asserts that a given value is of type `never`, which is useful for exhaustive type checking in TypeScript.
 *
 * This function should be used in places where all possible cases should have been handled,
 * and reaching this function indicates a logic error.
 *
 * @param value - The value that should be of type `never`.
 * @throws {Error} Throws an error indicating that this code path should never be executed.
 *
 * @see {@link https://stackoverflow.com/a/39419171/1860591}
 */
export function assertNever(value: never): never {
	throw new Error(`Unreachable code executed with value: ${toJSON(value)}`);
}
